












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
})
export default class SliderInput extends Vue {
  @Prop([Array, String]) value: [] | string;
  @Prop(Number) min: 0;
  @Prop(Number) max: 100;
  @Prop(Number) interval: 10;
  @Prop(Boolean) disabled: false;

  /* Destructuring v-model in a getter/setter to have a custom input container */
  get inputValue () {
    return this.value;
  }

  /* ⬆️ */
  set inputValue (value) {
    this.$emit('input', value);
  }
}
